import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const CustomerVerification = {
	name: NAME,
	apiProvider,
	router,
};
